import React, { Fragment } from "react";
import {
    Position,
    H5,
    Tag,
    InputGroup,
    FormGroup,
    Popover,
    Intent,
    Card,
    Checkbox,
    HTMLSelect
} from "@blueprintjs/core";
import Validator from "validator";
import Axios from "axios";
import FadeIn from 'react-fade-in';

import proto1 from '../../assets/proto1.png'
import proto2 from '../../assets/proto2.png'
import proto3 from '../../assets/proto3.png'
import proto4 from '../../assets/proto4.png'

import { countObjectKeys, getSessionFullUrl } from "../../helper";

import ProtocolCard from 'components/Creer/ProtocolCard'
import Alert from 'components/layout/alerts/Classic'

import Auth from "../../services/Auth";
import Session from "../../services/Session";
import { translate } from "utlis/translations/i18n";

const REBRAND_API_KEY = "59b5fd2965584c65b6725fc9ba8ec3f1";

class GeneralInfos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shortnameInvalid: false,
            shortnameTaken: false,
            selectedCard: '',
            alertProto: false,
            shouldPromptUserName: false
        };
        this.baseEndpoint = "";
    }

    isTakenShortname = shortname => {
        return new Promise(resolve => {
            Session.getSessionByUserAndShortname(
                Auth.getUserId(),
                shortname,
                false
            ).then(session => {
                // We get a list of session with the given shortname
                // We always have one session which is the current one we are building
                // But if we have more than one session, we consider the shortname as taken
                if (!session) return resolve(false);
                if (countObjectKeys(session) === 1) return resolve(false);
                return resolve(true);
            });
        });
    };

    handleChangeShortname = e => {
        const name = e.target.name;
        let value = e.target.value;
        const { onInputChange } = this.props;

        this.setState({ shortnameInvalid: false, shortnameTaken: false });
        if (!this.validateShortname(value)) {
            value = null;
            this.setState({ shortnameInvalid: true });
        }
        return onInputChange(name, value);
    };
    handleBlurShortname = e => {
        const name = e.target.name;
        let value = e.target.value;
        const { onInputChange, rebrandLinkId } = this.props;

        this.isTakenShortname(value).then(isTaken => {
            if (isTaken) {
                value = null;
                this.setState({ shortnameTaken: true });
            }
            onInputChange(name, value);
            if (rebrandLinkId != null)
                Axios.post(
                    `https://api.rebrandly.com/v1/links/${rebrandLinkId}`,
                    {
                        destination: getSessionFullUrl(window.location, {
                            metadata: { author: Auth.getUserId(), shortname: value }
                        })
                    },
                    {
                        headers: { apikey: REBRAND_API_KEY }
                    }
                );
            else
                Axios.post(
                    "https://api.rebrandly.com/v1/links",
                    {
                        destination: getSessionFullUrl(window.location, {
                            metadata: { author: Auth.getUserId(), shortname: value }
                        })
                    },
                    { headers: { apikey: REBRAND_API_KEY } }
                )
                    .then(response => response.data)
                    .then(responseData => {
                        onInputChange("shortUrl", responseData.shortUrl);
                        onInputChange("rebrandLinkId", responseData.id);
                    });
        });
    };

    handleChangeInput = e => {
        const name = e.target.name;
        let value = e.target.value;
        const { onInputChange } = this.props;

        if (name === "shortname" && !this.validateShortname(value)) {
            value = null;
            this.setState({ shortnameInvalid: true });
        } else this.setState({ shortnameInvalid: false });
        onInputChange(name, value);
    };

    validateShortname = str => {
        if (typeof str !== "string") return false;
        if (!Validator.isAlphanumeric(str)) return false;
        if (!Validator.isLength(str, { min: 4, max: 25 })) return false;
        if (Validator.isNumeric(str.trim().charAt(0))) return false;
        return true;
    };

    togglePromprUsername = () => {
        this.props.onInputChange('shouldPromptUserName', !this.props.shouldPromptUserName)
    }

    onChangeLanguage = e => {
        this.props.onInputChange('language', e.target.value)
    }


    chooseCard = e => {

        if ((this.props.resources && this.props.resources.length > 0)
            || (this.props.msCriterias && this.props.msCriterias.length > 0)
            || (this.props.mcCriterias && this.props.mcCriterias.length > 0)) {
            this.setState({ alertProto: true })
        } else {
            let protocol = e.target.id
            if (protocol === 'MC' || protocol === 'CM') {
                this.setState({ selectedCard: protocol }, () => {
                    this.props.onInputChange('protocol', protocol)
                    this.props.onInputChange('type', "AUTONOMOUS")
                })
            } else {
                this.setState({ selectedCard: protocol }, () => {
                    this.props.onInputChange('protocol', protocol)
                })
            }
        }
    }

    render() {
        const {
            name,
            shortname
        } = this.props;

        const { selectedCard, alertProto } = this.state

        const helpNameContent = (
            <div className="create-session-popover-content" key="text">
                <H5>Name</H5>
                <p>
                    This is the name of your session. It will be visible for people playing your session.
                </p>
            </div>
        );
        const helpNameTag = (
            <Popover content={helpNameContent} >
                <Tag className="cursor-pointer">Help</Tag>
            </Popover>
        );
        const helpShortnameContent = (
            <div className="create-session-popover-content" key="text">
                <H5>Shortname</H5>
                <p>
                    Shortname will be part of URL used to play your session.
                    <br />
                    <br />
                    Exemple
                    <br />
                    <code>
                        https://app.visualsense.fr/join/<strong>shortname</strong>
                    </code>
                </p>
            </div>
        );
        const helpShortnameTag = (
            <Popover content={helpShortnameContent} position={Position.RIGHT}>
                <Tag className="cursor-pointer">Help</Tag>
            </Popover>
        );

        return (
            <Fragment>
                <Alert
                    isOpen={alertProto}
                    onClose={() => this.setState({ alertProto: false })}
                    title='You already defined protocol'
                    intent={Intent.DANGER}
                    icon="error"
                    text={<p>
                        You can not redefine protocol once you already downloaded images
                    </p>}
                    confirmButtonText="Ok"
                />
                <div className="row">
                    <div className="col-xs-12 col-md-12 margin-bottom-medium">
                        <Card className='row'>
                            <FormGroup label="Session Name*"
                                labelFor="name"
                                className='col-xs-12 col-md-6'
                            >
                                <InputGroup
                                    id="name"
                                    name="name"
                                    rightElement={helpNameTag}
                                    placeholder='Enter the name of your session here ...'
                                    onChange={this.handleChangeInput}
                                    defaultValue={name}
                                />
                            </FormGroup>
                            <FormGroup
                                label="Session Shortname*"
                                className='col-xs-12 col-md-6'
                                labelFor="shortname"
                                helperText={
                                    this.state.shortnameInvalid
                                        ? "It can contains only letters and numbers. Spaces are not allowed. Between 4 et 25 characters."
                                        : this.state.shortnameTaken
                                            ? "You have already used this shortname."
                                            : ""
                                }
                                intent={
                                    !this.state.shortnameInvalid && !this.state.shortnameTaken
                                        ? Intent.NONE
                                        : Intent.DANGER
                                }
                            >
                                <InputGroup
                                    id="shortname"
                                    name="shortname"
                                    placeholder='Enter the shortname of your session here ...'
                                    rightElement={helpShortnameTag}
                                    onChange={this.handleChangeShortname}
                                    onBlur={this.handleBlurShortname}
                                    intent={
                                        !this.state.shortnameInvalid && !this.state.shortnameTaken
                                            ? Intent.NONE
                                            : Intent.DANGER
                                    }
                                    defaultValue={shortname}
                                />
                            </FormGroup>
                            <FadeIn>
                                <div className="create-protocol-choice margin-top-medium margin-bottom-medium">
                                    <ProtocolCard
                                        selected={selectedCard === 'PC'}
                                        chooseCard={this.chooseCard}
                                        protocol="PC"
                                        imgSrc={proto2}
                                        desc="Participants will have to choose between two images on each sequences. You just have to download images and generate sequences. You can upload up to 6 images, which implies 15 sequences."
                                        demoLink="https://testvs-f96db.web.app/#/play/1t1miTtCqqPCRskRadPpqV1yhOw2/diorpc"
                                    />
                                    <ProtocolCard
                                        selected={selectedCard === 'MS'}
                                        chooseCard={this.chooseCard}
                                        protocol="MS"
                                        imgSrc={proto1}
                                        desc="Participants will face images one by one. They will have to vote regarding the criterias you will choose to ask. You will be able to configure these criterias just after uploading images."
                                        demoLink="https://testvs-f96db.web.app/#/play/1t1miTtCqqPCRskRadPpqV1yhOw2/diorpc"
                                    />
                                    <ProtocolCard
                                        selected={selectedCard === 'MC'}
                                        chooseCard={this.chooseCard}
                                        protocol="MC"
                                        imgSrc={proto3}
                                        desc="This protocol allows you to overlay multiple images. Participants will have the opportunity to vary the intensity of different images."
                                        demoLink="https://testvs-f96db.web.app/#/play/1t1miTtCqqPCRskRadPpqV1yhOw2/diorpc"
                                    />
                                    <ProtocolCard
                                        selected={selectedCard === 'CM'}
                                        chooseCard={this.chooseCard}
                                        protocol="CM"
                                        imgSrc={proto4}
                                        desc="Participants will have the opportunity to scroll the images and choose the one they prefer, in regards to the context question you will set."
                                        demoLink="https://testvs-f96db.web.app/#/play/1t1miTtCqqPCRskRadPpqV1yhOw2/diorpc"
                                    />
                                </div>
                                <div>
                                    <Checkbox checked={this.props.shouldPromptUserName} label={translate('shouldPromptUserName')} onChange={this.togglePromprUsername} />
                                </div>
                                <div>
                                <HTMLSelect
                                    fill={true}
                                    defaultValue={this.props.language}
                                    onChange={this.onChangeLanguage}
                                >
                                    <option value="fr">Francais</option>
                                    <option value="en">Anglais</option>
                                    <option value="cz">Tchèque</option>
                                    <option value="pl">Polonais</option>
                                </HTMLSelect>
                                </div>
                            </FadeIn>
                        </Card>
                    </div>
                </div>
            </Fragment>
        );
    }

    componentDidMount() {
        this.baseEndpoint = `sessions/${Auth.getUserId()}`;
        if (this.props.protocol && this.state.protocol !== '') {
            this.setState({ selectedCard: this.props.protocol, shouldPromptUserName: this.props.shouldPromptUserName })
        }
    }
}

export default GeneralInfos;
